export default {
  configure: {
    "B": {
      PID: "B",
      id: "",
      name: "",
      domainName: "",
      OSSDomain: "",
      mobUrlUser: "",
      mobUrlOrder: "",
      company: "望宿科技（北京）有限公司",
      content: "© 2022 望宿科技（北京）有限公司",
      recordNo: "",
      style: "@/assets/styles/tianrun",
      image: "@/assets/images/tianrun",
      logoImg: "assets/images/logo_wx.png",
      loginPage: '/#/login-wangxiu',
      accountTypeInfoArr: [
        { accountId: "", label: "系统账户", value: "2" },
        { accountId: "", label: "支付宝账户", value: "5" },
        { accountId: "", label: "汇付宝账户", value: "9" },
        { accountId: "", label: "民生账户", value: "10" },
        { accountId: "", label: "津盛账户", value: "11" },
        { accountId: "", label: "中新能账户", value: "12" },
        { accountId: "", label: "招商银行账户", value: "13" },
      ],
      accountTypeArray: [
        { accountId: "", label: "支付宝账户", value: 5 },
        { accountId: "", label: "汇付宝账户", value: 9 },
        { accountId: "", label: "微信账户", value: 6 },
        { accountId: "", label: "民生账户", value: 10 },
        { accountId: "", label: "津盛账户", value: 11 },
        { accountId: "", label: "中新能账户", value: 12 },
        { accountId: "", label: "招商银行账户", value: 13 },
      ],
      accountArray: [
        { accountId: "", label: "支付宝账户", value: 5 },
        { accountId: "", label: "微信账户", value: 6 },
        { accountId: "", label: "民生账户", value: 10 },
        { accountId: "", label: "津盛账户", value: 11 },
        { accountId: "", label: "中新能账户", value: 12 },
        { accountId: "", label: "招商银行账户", value: 13 }
      ],
      accountTypeArr: [
        { accountId: "", label: "支付宝", value: 5 },
        { accountId: "", label: "汇付宝", value: 9 },
        { accountId: "", label: "民生", value: 10 },
        { accountId: "", label: "津盛", value: 11 },
        { accountId: "", label: "中新能", value: 12 },
        { accountId: "", label: "招商银行", value: 13 }
      ],
      paymentChannelArray: [
        { accountId: "", label: "支付宝", value: 5 },
        { accountId: "", label: "汇付宝", value: 9 },
        { accountId: "", label: "微信", value: 6 },
        { accountId: "", label: "民生", value: 10 },
        { accountId: "", label: "津盛", value: 11 },
        { accountId: "", label: "中新能", value: 12 },
        { accountId: "", label: "招商银行", value: 13 }
      ],
      fromTypeArr: [
        { accountId: "", label: "支付宝支付", value: "5" },
        { accountId: "", label: "民生银行支付", value: "10" },
        { accountId: "", label: "津盛支付", value: "11" },
        { accountId: "", label: "中新能支付", value: "12" },
        { accountId: "", label: "招商银行支付", value: "13" }
      ],
      reconciliationArr: [
        { accountId: "", label: "支付宝支付", value: "5" },
        { accountId: "", label: "汇付宝支付", value: "9" },
        { accountId: "", label: "微信支付", value: "6" },
        { accountId: "", label: "民生银行支付", value: "10" },
        { accountId: "", label: "津盛支付", value: "11" },
        { accountId: "", label: "中新能支付", value: "12" },
        { accountId: "", label: "招商银行支付", value: "13" }
      ],
      paymentChannelArr: [
        { accountId: "", label: "系统账户支付", value: "2" },
        { accountId: "", label: "线下支付", value: "3" },
        { accountId: "", label: "支付宝支付", value: "5" },
        { accountId: "", label: "汇付宝支付", value: "9" },
        { accountId: "", label: "微信支付", value: "6" },
        { accountId: "", label: "民生银行支付", value: "10" },
        { accountId: "", label: "津盛支付", value: "11" },
        { accountId: "", label: "中新能支付", value: "12" },
        { accountId: "", label: "招商银行支付", value: "13" }
      ],
      orderStatusArr: [
        {accountId: "", label: "挂单中", value: "notEnough"},
        {accountId: "", label: "同意支付", value: "agree"},
        {accountId: "", label: "拒绝支付", value: "disAgree"}
      ],
      auditFlagArray: [
        {accountId: "", label: "待充值", value: "0"},
        {accountId: "", label: "审核中", value: "1"},
        {accountId: "", label: "支付中", value: "2"},
        {accountId: "", label: "线下支付", value: "3"},
        {accountId: "", label: "支付完成", value: "4"},
        {accountId: "", label: "已驳回", value: "5"},
        {accountId: "", label: "取消支付", value: "6"},
        {accountId: "", label: "支付失败", value: "8"},
        {accountId: "", label: "API支付中", value: "9"},
        {accountId: "", label: "API支付完成", value: "10"},
      ],
      auditFlagArr: [
        {accountId: "", label: "待审核", value: "0"},
        {accountId: "", label: "已充值", value: "1"},
        {accountId: "", label: "已驳回", value: "2"},
        {accountId: "", label: "已退回", value: "3"},
      ],
      orderTypeArray: [
        {accountId: "", label: "批量支付", value: 1},
        {accountId: "", label: "API支付", value: 2},
        {accountId: "", label: "单笔支付", value: 3},
        {accountId: "", label: "快捷支付", value: 4},
      ],
      payStatusArray: [
        {accountId: "", label: "待支付", value: "0"},
        {accountId: "", label: "支付中", value: "1"},
        {accountId: "", label: "支付成功", value: "2"},
        {accountId: "", label: "支付失败", value: "3"},
        {accountId: "", label: "退汇成功", value: "5"},
      ],
      payStatuNewArr: [
        {accountId: "", label: "支付中", value: "1"},
        {accountId: "", label: "支付成功", value: "2"},
        {accountId: "", label: "支付失败", value: "3"},
      ],
      returnRemittanceArr: [
        {accountId: "", label: "待处理", value: "0"},
        {accountId: "", label: "已处理", value: "1"},
        {accountId: "", label: "不处理", value: "2"},
      ],
      prepaidArr: {
        prepaidStatusArr: [
          {accountId: "", label: "预付中", value: "DEALING"},
          {accountId: "", label: "预付成功", value: "SUCCESS"},
          {accountId: "", label: "预付失败", value: "FAIL"},
        ],
        returnStatusArr: [
          {accountId: "", label: "退还中", value: "DEALING"},
          {accountId: "", label: "退还成功", value: "SUCCESS"},
          {accountId: "", label: "退还失败", value: "FAIL"},
        ],
        prepaidTypeArr: [
          {accountId: "", label: "线上预付", value: "online"},
          {accountId: "", label: "线下预付", value: "offline"},
          {accountId: "", label: "线上转为线下预付", value: "onlineToOffline"},
          {accountId: "", label: "驳回", value: "reject"},
        ],
      },
      valueArray: {
        statusValueArr: [
          {accountId: "", label: "招标中", value: "0"},
          {accountId: "", label: "已开工", value: "1"},
          {accountId: "", label: "已完工", value: "2"},
        ],
        operateValueArr: [
          {accountId: "", label: "待审核", value: "0"},
          {accountId: "", label: "已通过", value: "1"},
          {accountId: "", label: "已驳回", value: "2"},
          {accountId: "", label: "已停用", value: "3"},
        ]
      },
      phaseStatusArr: [
        {accountId: "", label: "待审核", value: "0"},
        {accountId: "", label: "通过", value: "1"},
        {accountId: "", label: "拒绝", value: "9"},
      ],
      billAuditFlagArr: [
        {accountId: "", label: "待审核", value: "0"},
        {accountId: "", label: "已开票", value: "1"},
        {accountId: "", label: "已驳回", value: "2"},
        {accountId: "", label: "开票金额作废", value: "6"},
      ],
      billTypeArray: [
        {accountId: "", label: "增值税普通电子发票", value: 1},
        {accountId: "", label: "增值税专用电子发票", value: 2},
        {accountId: "", label: "增值税普通纸质发票", value: 3},
        {accountId: "", label: "增值税专用纸质发票", value: 4},
      ],
      settlAuditArray: [
        {accountId: "", label: "待审核", value: "0"},
        {accountId: "", label: "已通过", value: "1"},
        {accountId: "", label: "已取消", value: "2"},
      ],
      statusValueArray: [
        {accountId: "", label: "退款审核", value: "0"},
        {accountId: "", label: "退款中", value: "1"},
        {accountId: "", label: "退款完成", value: "2"},
        {accountId: "", label: "线下退款", value: "3"},
        {accountId: "", label: "已驳回", value: "4"},
        {accountId: "", label: "退款失败", value: "5"},
      ],
      refundStatusArr: [
        {accountId: "", label: "审核中", value: "checking"},
        {accountId: "", label: "审核通过", value: "refunded"},
        {accountId: "", label: "已驳回", value: "reject"},
      ],
      fileSourceArr: [
        {accountId: "", label: "默认", value: "0"},
        {accountId: "", label: "E签宝", value: "1"},
        {accountId: "", label: "后台", value: "2"},
        {accountId: "", label: "API", value: "3"},
      ],
      errorCodeTypeArr: [
        {accountId: "", label: "支付宝", value: "5"},
        {accountId: "", label: "微信", value: "6"},
        {accountId: "", label: "民生", value: "10"},
        {accountId: "", label: "津盛", value: "11"},
        {accountId: "", label: "中新能", value: "12" },
        {accountId: "", label: "招商银行", value: "13" }
      ],
      pushTypeArr: [
        {accountId: "", label: "银行卡", value: "1"},
        {accountId: "", label: "支付宝", value: "2"},
        {accountId: "", label: "微信", value: "3"},
      ],
      refundPaymentStatusArr: [
        {accountId: "", label: "支付中", value: "DEALING"},
        {accountId: "", label: "转账成功", value: "SUCCESS"},
        {accountId: "", label: "线下支付", value: "OFFLINE"},
        {accountId: "", label: "转账失败", value: "FAIL"},
      ],
      balancejectArray: [
        {accountId: "", label: "代理商分润", value: "0024"},
        {accountId: "", label: "商户分润", value: "0004"},
        {accountId: "", label: "提现订单", value: "0011"},
        {accountId: "", label: "系统加款", value: "0012"},
        {accountId: "", label: "系统扣款", value: "0013"},
        {accountId: "", label: "提现驳回", value: "0014"},
        {accountId: "", label: "银行退汇", value: "0017"},
        {accountId: "", label: "提现扣税金额", value: "0027"},
        {accountId: "", label: "提现扣税金额退还", value: "0028"},
      ],
      serviceTypeArray: [
        {accountId: "", label: "商户充值服务费", value: "1"},
        {accountId: "", label: "平台提现", value: "2"},
        {accountId: "", label: "支付宝加款", value: "3"},
        {accountId: "", label: "支付宝扣款", value: "4"},
        {accountId: "", label: "分流预付", value: "5"},
        {accountId: "", label: "分流退还", value: "6"},
        {accountId: "", label: "分流支付", value: "7"},
        {accountId: "", label: "手续费转账", value: "8"},
      ],
      customTypeArray: [
        {accountId: "", label: "商户", value: 1},
        {accountId: "", label: "服务商", value: 2},
        {accountId: "", label: "代理商", value: 3},
        {accountId: "", label: "个人", value: 4},
        {accountId: "", label: "后台管理", value: 5},
        {accountId: "", label: "个体户", value: 0},
      ],
      customTypeNameArr: [
        {accountId: "", label: "系统管理员", value: "1"},
        {accountId: "", label: "商户", value: "2"},
        {accountId: "", label: "服务商", value: "3"},
        {accountId: "", label: "代理商", value: "4"},
        {accountId: "", label: "个人", value: "5"},
        {accountId: "", label: "个体户", value: "6"},
        {accountId: "", label: "平台", value: "7"},
      ],
      balanceSubjectArr: [
        {accountId: "", label: "发放费用", value: "0001"},
        {accountId: "", label: "服务费", value: "0002"},
        {accountId: "", label: "充值", value: "0003"},
        {accountId: "", label: "月结分润", value: "0004"},
        {accountId: "", label: "季结分润", value: "0005"},
        {accountId: "", label: "返还金额", value: "0006"},
        {accountId: "", label: "系统加款", value: "0007"},
        {accountId: "", label: "系统扣款", value: "0008"},
        {accountId: "", label: "支付宝加款", value: "0015"},
        {accountId: "", label: "支付宝扣款", value: "0016"},
        {accountId: "", label: "退款申请", value: "0009"},
        {accountId: "", label: "退款返还", value: "0010"},
        {accountId: "", label: "提现订单", value: "0011"},
        {accountId: "", label: "提现订单驳回", value: "0014"},
        {accountId: "", label: "银行退汇", value: "0017"},
        {accountId: "", label: "对公手续费扣除", value: "0018"},
        {accountId: "", label: "对公手续费退还", value: "0019"},
        {accountId: "", label: "商户退款", value: "0025"},
        {accountId: "", label: "商户退款返还", value: "0026"},
        {accountId: "", label: "个税扣除", value: "0031"},
        {accountId: "", label: "退汇返还个税", value: "0032"},
        {accountId: "", label: "个税返还", value: "0033"},
      ],
      signingStatusArr: [
        {accountId: "", label: "未认证", value: "EMPTY"},
        {accountId: "", label: "未认证", value: "UN_AUTH"},
        {accountId: "", label: "待审核", value: "AUTHING"},
        {accountId: "", label: "已认证", value: "AUTHED"},
        {accountId: "", label: "已签署", value: "SIGNED"},
        {accountId: "", label: "已驳回", value: "NOT_AUTH"},
        {accountId: "", label: "已注销", value: "DELETED"},
      ],
      balanceSubArr: [
        {accountId: "", label: "支付", value: "0001"},
        {accountId: "", label: "服务费", value: "0002"},
        {accountId: "", label: "充值", value: "0003"},
        {accountId: "", label: "支付返还", value: "0006"},
        {accountId: "", label: "系统加款", value: "0007"},
        {accountId: "", label: "系统扣款", value: "0008"},
        {accountId: "", label: "支付宝加款", value: "0015"},
        {accountId: "", label: "支付宝扣款", value: "0016"},
        {accountId: "", label: "退款申请", value: "0009"},
        {accountId: "", label: "退款返还", value: "0010"},
      ],
      channelArray: [
        {accountId: "", label: "支付宝配置", value: "ALI_PAY_SETTING"},
        {accountId: "", label: "微信配置", value: "WE_CHAT_PAY_SETTING"},
        {accountId: "", label: "民生配置", value: "MIN_SHENG_PAY_SETTING"},
        {accountId: "", label: "支付宝配置", value: "HEE_PAY_SETTING"},
        {accountId: "", label: "中新能配置", value: "ZXN_PAY_SETTING"},
        {accountId: "", label: "招商银行配置", value: "CMB_PAY_SETTING"},
      ],
      bindingTypeArr: [
        {accountId: "", label: "-", value: "0"},
        {accountId: "", label: "父级", value: "1"},
        {accountId: "", label: "子级", value: "2"},
        {accountId: "", label: "子级审核中", value: "3"},
        {accountId: "", label: "父级审核中", value: "4"},
      ],
      updateTypeArray: [
        {accountId: "", label: "商户关联代理商", value: "0"},
        {accountId: "", label: "代理商新增", value: "1"},
        {accountId: "", label: "代理商编辑", value: "2"},
        {accountId: "", label: "代理商关联代理商", value: "3"},
        {accountId: "", label: "解绑代理商", value: "4"},
        {accountId: "", label: "代理商提现规则", value: "5"},
      ],
      serviceFormulaArr: [
        {accountId: "", label: "外扣", value: "1"},
        {accountId: "", label: "内扣", value: "2"},
      ],
      signTypeArr: [
        {accountId: "", label: "不使用", value: "UN_USED"},
        {accountId: "", label: "不校验", value: "UN_CHECK"},
        {accountId: "", label: "二要素", value: "TWO_CHECK"},
        {accountId: "", label: "三要素", value: "THREE_CHECK"},
        {accountId: "", label: "四要素", value: "FORE_CHECK"},
      ],
      pictureSwitchArr: [
        {accountId: "", label: "上传", value: 1},
        {accountId: "", label: "不上传", value: 0}
      ],
      exemptionSwitchArr:[
        {accountId: "", label: "免征", value: 1},
        {accountId: "", label: "不免征", value: 0},
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/configure.js